"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class NotificationController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: '/v1/notification/organisation',
            add: '/v1/notification/organisation',
            delete: '/v1/notification/organisation/:objectId',
            listEndpoints: '/v1/admin/config/endpoint',
            addOrganisationEndpoint: '/v1/admin/config/organisation/endpoint',
            deleteOrganisationEndpoint: '/v1/admin/config/organisation/endpoint/:endpointName',
            addGlobalEndpoint: '/v1/admin/config/global/endpoint',
            deleteGlobalEndpoint: '/v1/admin/config/global/endpoint/:endpointName',
        };
    }
    listEndpoints() {
        return this.manager.get({
            url: this.endpoints.listEndpoints,
        });
    }
    add(notification) {
        return this.manager.put({
            url: this.endpoints.add,
        }, notification);
    }
    addOrganisationEndpoint(endpoint) {
        return this.manager.put({
            url: this.endpoints.addOrganisationEndpoint,
        }, endpoint);
    }
    addGlobalEndpoint(endpoint) {
        return this.manager.put({
            url: this.endpoints.addGlobalEndpoint,
        }, endpoint);
    }
    deleteGlobalEndpoint(endpointName) {
        return this.manager.delete({
            url: this.endpoints.deleteGlobalEndpoint,
            params: { endpointName },
        });
    }
    deleteOrganisationEndpoint(endpointName) {
        return this.manager.delete({
            url: this.endpoints.deleteOrganisationEndpoint,
            params: { endpointName },
        });
    }
}
exports.default = NotificationController;
